import repo from '../services/propertyListingRepo';
import routing from '../services/propertyListingRouting';

const pageTitleType = 'Properties';

// Helper function to determine if commercial properties should be shown
const getIsCommercial = () => {
    const path = window.location.pathname;

    // For /search/ pages, use URL-based detection as the source of truth
    if (path.startsWith('/search/')) {
        return path.split('/')[2] === 'commercial';
    }

    // For other pages (e.g. GeographicArea), use the data attribute
    const element = document.querySelector('[data-show-commercial-properties]');
    if (element && element.dataset.showCommercialProperties !== undefined) {
        return element.dataset.showCommercialProperties.toLowerCase() === 'true';
    }

    return false;
};

export default {
    data: function() {
        return {
            isLoading: false,
            isDev: false,
            api: {},
            state: {
                isCommercial: getIsCommercial(),
                page: {
                    no: 0,
                    size: 50,
                    sizeForMap: 100
                },
                orderBy: '',
                map: false,
                hideLetAgreed: false,
                filters: {}
            }
        }
    },
    computed: {
        pageSize: {
            get: function() {
                return this.state.map ? this.state.page.sizeForMap : this.state.page.size;
            }
        }
    },
    methods: {
        initData: function(blockHelper) {
            this.isDev = document.documentElement.dataset.frontendEnvironment === 'true';
            this.api = this.isDev ? repo.apiDev : repo.apiLive;

            this.api.search(this.state, this.pageSize, true).then((response) => {

                blockHelper.assign(this, response.data);

                this.state.orderBy = this.vm.sortField.defaultValue;

                // Get preSetAreas from data attribute if available (for geographic area pages)
                // This needs to happen BEFORE setting default values
                const preSetAreasElement = document.querySelector('[data-preset-areas]');
                console.log('[PreSetAreas] Element found:', preSetAreasElement);
                console.log('[PreSetAreas] Dataset:', preSetAreasElement?.dataset);

                let hasPreSetAreas = false;
                let preSetAreas = [];

                if (preSetAreasElement && preSetAreasElement.dataset.presetAreas) {
                    try {
                        preSetAreas = JSON.parse(preSetAreasElement.dataset.presetAreas);
                        console.log('[PreSetAreas] Parsed preSetAreas:', preSetAreas);
                        hasPreSetAreas = preSetAreas && preSetAreas.length > 0;
                    } catch (e) {
                        console.error('[PreSetAreas] Error parsing preSetAreas:', e);
                    }
                }

                // Set default values for all fields, but skip area if we have presets
                this.vm.searchFields.forEach((e) => {
                    if (e.name === 'area' && hasPreSetAreas) {
                        // Skip setting default values for area - we'll use presets instead
                        console.log('[PreSetAreas] Skipping default values for area field');
                    } else {
                        this.state.filters[e.name] = e.defaultValues;
                    }
                });

                // Now apply the preset areas
                if (hasPreSetAreas) {
                    const areaField = this.vm.searchFields.find(f => f.name === 'area');
                    console.log('[PreSetAreas] Area field found:', areaField);
                    console.log('[PreSetAreas] Area field elements:', areaField?.elements);

                    if (areaField) {
                        // PreSetAreas are already SEO-safe values, match by checkbox value
                        areaField.elements.forEach(elem => {
                            console.log('[PreSetAreas] Checking element:', {
                                label: elem.label,
                                value: elem.value,
                                isSelected: elem.isSelected,
                                matches: preSetAreas.includes(elem.value)
                            });

                            if (preSetAreas.includes(elem.value)) {
                                console.log('[PreSetAreas] MATCHED! Setting as selected:', elem.value);
                                elem.isSelected = true;
                            } else if (elem.value === 'all') {
                                elem.isSelected = false;
                            }
                        });

                        // Update the state filters to match
                        this.state.filters.area = preSetAreas;
                        console.log('[PreSetAreas] Updated state.filters.area:', this.state.filters.area);

                        // Hide the area filter if data-hide-area-filter is set
                        if (preSetAreasElement.dataset.hideAreaFilter === 'true') {
                            areaField.isHidden = true;
                            console.log('[PreSetAreas] Hiding area filter');
                        }
                    }
                }

                if(!this.vm.letAgreedToggle.isSelected) {
                    this.state.filters.hideUnderOffer = true;
                }

                routing.setPageTitle(this.state, pageTitleType);

            });
        },
        update: function(isSearch) {

            if(isSearch) {
                //must clear property list for splide lazy loading to work!
                this.vm.properties = [];
                this.vm.relatedProperties = {};
                this.state.page.no = 0;
            }

            this.api.search(this.state, this.pageSize).then((response) => {

                this.clearDevelopment();

                this.vm.recordCount = response.data.recordCount;
                this.vm.searchFields = response.data.searchFields;

                if(isSearch) {
                    this.vm.properties = response.data.properties;
                    this.vm.relatedProperties = response.data.relatedProperties;
                    this.forceFilterResize();
                    this.updateMapMarkers(response.data.map.markers);
                    this.resetMap();
                }
                else {
                    this.vm.properties = [...this.vm.properties, ...response.data.properties];
                }
                this.isLoading = false;
                if(!this.isDev) {
                    routing.setHistoryPushStateFromState(this.state, pageTitleType);
                    this.vm.searchFields = response.data.searchFields;
                }
                if(!isSearch) {
                    window.scroll(window.scrollX, this.previousScrollPosition);
                }
            });
        },
        page: function() {
            this.isLoading = true;
            this.state.page.no ++;
            this.update(false);
            this.previousScrollPosition = window.scrollY;
        },
        sort: function(orderBy) {
            this.state.orderBy = orderBy;
            this.update(true);
        },
        clear: function() {

            var promises = [];
            this.$refs.filters.forEach(filter => {
                promises.push(filter.clear());                    
            });
            Promise.all(promises).then(() => 
                this.update(true)
            );
        },
        updateHistoryPushState: function() {
            if(!this.isDev) {
                routing.setHistoryPushStateFromState(this.state, );
            }
        }
    }
}